import { styled, Typography, useTheme } from "@mui/material";
import { Filters, Pill } from "@volt_developers/components";
import { ReactNode } from "react";

import { FILTERS_TEST_IDS } from "../../../constants";

type QuickFiltersValue = { key: string; value: string };

export interface QuickFiltersProps {
  activeFilters: string[];
  handleClick: (filter: string) => void;
  label: ReactNode;
  quickFilters: QuickFiltersValue[];
}

export function QuickFilters({
  activeFilters,
  quickFilters,
  handleClick,
  label,
}: QuickFiltersProps) {
  const theme = useTheme();

  return (
    <Filters.Item data-testid={FILTERS_TEST_IDS.quickFilters} label={label}>
      <Wrapper>
        {quickFilters.map(({ key, value }) => {
          const isActive = activeFilters.includes(key);
          const backgroundColor = isActive ? ACTIVE_COLOR : theme.palette.ui55;
          const color = isActive
            ? theme.palette.text.highlight
            : theme.palette.text.secondary;

          return (
            <FilterWrapper
              key={key}
              aria-selected={isActive}
              data-testid={FILTERS_TEST_IDS.getQuickFilter(key)}
              onClick={() => handleClick(key)}
            >
              <Pill
                backgroundColor={backgroundColor}
                borderColor={backgroundColor}
                color={color}
              >
                <Typography variant="h7">{value}</Typography>
              </Pill>
            </FilterWrapper>
          );
        })}
      </Wrapper>
    </Filters.Item>
  );
}

const ACTIVE_COLOR = "#D5E9FF";

const Wrapper = styled("div")({
  display: "flex",
  flexDirection: "row",
  gap: "inherit",
});

const FilterWrapper = styled("div")({
  cursor: "pointer",
});
